import { Avatar, Separator } from "@/elements"
import clsx from "clsx"
import React from "react"

interface Props {
  showSkeletonImage: boolean
  contentClassName?: string
  isDrawerVersion: boolean
}

export const JobDetailsContentSkeleton: React.FC<Props> = ({
  showSkeletonImage,
  contentClassName,
  isDrawerVersion,
}) => {
  const backgroundClassName = isDrawerVersion ? "bg-bg-2" : "bg-bg-3"

  return (
    <div className={clsx("relative h-full w-full", !isDrawerVersion && "mt-[40px]")}>
      {showSkeletonImage ? (
        <div className={clsx("h-[260px] w-full animate-pulse", backgroundClassName)} />
      ) : (
        <div className={clsx(isDrawerVersion && "mt-8")} />
      )}
      <div
        className={clsx(
          "mx-auto w-full",
          isDrawerVersion && "px-5 sm:px-16 md:max-w-[720px] md:px-12",
          contentClassName
        )}>
        <div className={clsx("flex flex-row items-center", isDrawerVersion && "md:mt-16")}>
          <Avatar size="xl" className="mr-5" />
          <div>
            <div className={clsx("h-[20px] w-[160px] animate-pulse", backgroundClassName)} />
            <div className={clsx("mt-2 h-[20px] w-[260px] animate-pulse", backgroundClassName)} />
          </div>
        </div>
        <div className={clsx("mt-6 h-[40px] w-full animate-pulse", backgroundClassName)} />
        <div className={clsx("mt-6 h-[36px] w-[140px] animate-pulse rounded-full", backgroundClassName)} />
        <div className="my-6 w-full">
          <Separator />
        </div>
        <div className={clsx("h-[20px] w-[85px] animate-pulse", backgroundClassName)} />
        <div className={clsx("mt-4 h-[20px] w-full animate-pulse", backgroundClassName)} />
        <div className={clsx("mt-2 h-[20px] w-full animate-pulse", backgroundClassName)} />
        <div className={clsx("mt-2 h-[20px] w-full animate-pulse", backgroundClassName)} />
        <div className={clsx("mt-2 h-[20px] w-1/2 animate-pulse", backgroundClassName)} />
        <div className="mt-6 flex flex-row gap-1">
          <div className={clsx("h-[32px] w-[90px] animate-pulse rounded-full bg-bg-2", backgroundClassName)} />
          <div className={clsx("h-[32px] w-[80px] animate-pulse rounded-full bg-bg-2", backgroundClassName)} />
          <div className={clsx("h-[32px] w-[100px] animate-pulse rounded-full bg-bg-2", backgroundClassName)} />
        </div>
      </div>
    </div>
  )
}
